import { css } from '@emotion/react';
import { Button, Form, FormProps, Row, Select, Typography } from 'antd';
import {
  watchListSizeDish,
  getListSizeDish
} from '@/redux/slices/dish.slice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useEffect } from 'react';
import { useQuery } from '@/hooks/query.hook';
type DishSizeModalProps = {
  size?: string;
  callback?: (size: { label: string; value: string }) => void;
  changeSize?: (size: string, label: string, newSize: string, dishSizeId?: string) => void;
  onCancel: () => void;
  items: ItemTab[];
  existingSizes?: ListSizeItem[];
};
type ItemTab = {
  key: string;
  label: string;
  sizeType: string;
  closable: boolean,
  children: React.ReactNode;
}
export default function NewDishSizeModal({
  size,
  callback,
  changeSize,
  onCancel,
  items,
  existingSizes
}: DishSizeModalProps) {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const listSizeDish = useAppSelector(watchListSizeDish);
  const { dishSizeId } = useQuery();

  const sizeDishGroupOptions = listSizeDish.map(item => ({
    value: item.id,
    label: item.name
  }));

  useEffect(() => {
    dispatch(getListSizeDish());
  }, [dispatch]);

  const onFinish: FormProps<CreateAdminUserProps>['onFinish'] = () => {
    const sizeValue = form.getFieldValue('size');
    const existingSizeTypes = existingSizes 
      ? existingSizes.map(item => item.sizeType)
      : items.map(item => item.sizeType);

    if (typeof size === 'string') {
      const otherSizeTypes = existingSizeTypes.filter(type => type !== size);
      if (otherSizeTypes.includes(sizeValue.value)) {
        form.setFields([{
          name: 'size',
          errors: ['Cỡ món đã tồn tại!']
        }]);
        return;
      }
    } else {
      if (existingSizeTypes.includes(sizeValue.value)) {
        form.setFields([{
          name: 'size',
          errors: ['Cỡ món đã tồn tại!']
        }]);
        return;
      }
    }

    if (typeof size === 'string') {

      if (changeSize) {
        if (sizeValue.value != size) {
          changeSize(size, sizeValue.label, sizeValue.value, dishSizeId);
        } else {
          changeSize(size, sizeValue.label, sizeValue.value);
        }
      }
    } else {
      if (callback) callback({ label: sizeValue.label, value: sizeValue.value });
    }

    onCancel();
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <Typography.Title level={4}>
        {typeof size === 'string' ? 'Chỉnh sửa cỡ món ăn' : 'Thêm cỡ món ăn'}
      </Typography.Title>

      <Row align={'middle'} css={rowStyles}>
        <Form.Item
          name={'size'}
          label={'Cỡ món ăn'}
          initialValue={size && sizeDishGroupOptions.find(opt => opt.value === size)}
          rules={[{ required: true, message: 'Vui lòng điền thông tin!' }]}
        >
          <Select
            options={sizeDishGroupOptions}
            labelInValue
            placeholder='Chọn cỡ món ăn'
            css={selectStyles}
          />
        </Form.Item>
      </Row>

      <div css={groupButtonStyles}>
        <Button type='default' size='large' onClick={onCancel}>
          Hủy
        </Button>

        <Button type='primary' size='large' htmlType='submit'>
          Lưu
        </Button>
      </div>
    </Form>
  );
}

const rowStyles = css`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  .ant-form-item-label > label {
    font-size: 1.4rem !important;
  }
`;

const selectStyles = css`
  width: 20rem !important;
`;

const groupButtonStyles = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 1.6rem;

  button {
    padding: 1rem 10rem;
  }
`;
